import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiBase } from 'services/apiBaseUrl';
import { getActiveAuthHeaders } from 'utils/getActiveAuthHeaders';

const prepareHeaders = (headers, { getState }) => {
  const authHeaders = getActiveAuthHeaders(getState());
  if (authHeaders.authorization) {
    headers.set('authorization', authHeaders.authorization);
  }
  if (authHeaders['x-company']) {
    headers.set('x-company', authHeaders['x-company']);
  }
  return headers;
};

const baseQuery = fetchBaseQuery({
  baseUrl: apiBase(),
  prepareHeaders,
});

export default baseQuery;
